<div class="entity-config-detail-page container-fluid px-2 px-md-3 py-1">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto">
    <section class="entity-detail-hero-shell rounded-4 shadow-sm overflow-hidden">
      <div class="bg-transparent px-3 px-md-3 pt-1 pb-0">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-detail-title-vibrant text-white fw-bold lh-sm mb-1">
              {{ entity_type_name }} Entity
            </h1>
            <p class="entity-detail-subcopy text-white mb-0">
              Seamlessly orchestrate and scale multi-cloud automation nodes and configuration schemas.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <div class="d-flex d-sm-inline-flex">
              <button
                type="button"
                class="btn btn-light btn-sm rounded-small shadow-sm fw-semibold d-inline-flex align-items-center justify-content-center px-3 py-1 entity-action-btn border-0 text-white text-nowrap"
                @click="go_to_bind_subsystems"
              >
                <i class="bi bi-link-45deg me-2 text-white"></i>
                Bind Subsystems
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-2 entity-detail-metric-wrap">
        <div class="row g-2 entity-detail-top-metrics">
          <div class="col-12 col-sm-6 col-xl-4">
            <article class="entity-metric-card rounded-4 p-3 h-100">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">Forms</span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ form_bindings.length }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-file-earmark-text"></i>
                </div>
              </div>
              <div class="d-none text-success">+2 from last week</div>
            </article>
          </div>

          <div class="col-12 col-sm-6 col-xl-4">
            <article class="entity-metric-card rounded-4 p-3 h-100">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">Workflows</span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ workflow_bindings.length }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-diagram-3"></i>
                </div>
              </div>
              <div class="d-none text-primary">Stable performance</div>
            </article>
          </div>

          <div class="col-12 col-xl-4">
            <article class="entity-metric-card rounded-4 p-3 h-100">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">Rules</span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ rule_bindings.length }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-sliders"></i>
                </div>
              </div>
              <div class="d-none text-danger">Active enforcements</div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="row g-2">
      <div class="col-12 col-xl-8">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-6 fw-bold mb-1">Active Configuration Bindings</h2>
              <div class="entity-panel-caption small fw-semibold">Core orchestration bindings for this entity.</div>
            </div>
            <div class="d-flex align-items-center gap-2 text-secondary">
              <i class="bi bi-funnel small"></i>
              <i class="bi bi-three-dots-vertical small"></i>
            </div>
          </div>

          <div class="d-flex flex-column gap-2">
            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white">
                    <i class="bi bi-file-earmark-text-fill"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">{{ form_bindings[0]?.form_name || 'Primary Intake Form' }}</div>
                    <div class="small text-secondary">Core data capture for supplier onboarding entity.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">Active</span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="d-flex align-items-center gap-1 text-secondary">
                  <span class="entity-face rounded-circle"></span>
                  <span class="entity-face rounded-circle"></span>
                  <span class="entity-face rounded-circle"></span>
                </div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_create_form">Manage Form <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>

            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white entity-vibrant-binding-icon-violet">
                    <i class="bi bi-diagram-3-fill"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">{{ workflow_bindings[0]?.workflow_name || 'Standard Approval Flow' }}</div>
                    <div class="small text-secondary">Automated hierarchy routing for stakeholder sign-off.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">Active Use</span>
              </div>
              <div class="small text-secondary mb-1">Workflow Efficiency <span class="float-end fw-semibold text-dark">94%</span></div>
              <div class="entity-mini-progress mb-2 rounded-pill overflow-hidden">
                <div class="entity-mini-progress-bar"></div>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-secondary">Last modification 2 hours ago</div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_create_workflow">Edit Flow <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>

            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white entity-vibrant-binding-icon-rose">
                    <i class="bi bi-shield-check"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">{{ rule_bindings[0]?.rule_name || 'Compliance Engine' }}</div>
                    <div class="small text-secondary">Legal and regulatory enforcement logic for regional entities.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-review rounded-pill fw-bold text-uppercase">Enforcement</span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="d-flex gap-1">
                  <span class="entity-mini-tag d-inline-flex align-items-center justify-content-center">GDPR</span>
                  <span class="entity-mini-tag d-inline-flex align-items-center justify-content-center">SOC2</span>
                </div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_compliance_management">Edit Ruleset <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>

            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white">
                    <i class="bi bi-file-earmark-richtext-fill"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">Linked Templates</div>
                    <div class="small text-secondary">Reusable document and content templates mapped to this entity.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">Available</span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-secondary">Open template library for this entity context</div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_view_template">View Templates <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>

            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white entity-vibrant-binding-icon-violet">
                    <i class="bi bi-patch-check-fill"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">Verification Services</div>
                    <div class="small text-secondary">Identity, compliance, and external verification services linked to this entity.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-review rounded-pill fw-bold text-uppercase">Connected</span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-secondary">Review and manage verification integrations</div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_verification_services">Manage Verification <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>

            <article class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75">
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div class="entity-vibrant-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center text-white entity-vibrant-binding-icon-rose">
                    <i class="bi bi-diagram-3-fill"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">Child Entities</div>
                    <div class="small text-secondary">Manage sub-entity structures, relationships, and downstream onboarding requirements.</div>
                  </div>
                </div>
                <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">Structured</span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-secondary">Configure entity hierarchy and child requirements</div>
                <button type="button" class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link" @click="go_to_manage_sub_entities">Manage Children <i class="bi bi-arrow-right-short"></i></button>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <h2 class="fs-6 fw-bold mb-0">Recent Activity</h2>
            <i class="bi bi-filter text-secondary small"></i>
          </div>

          <div v-if="recent_activities.length" class="entity-activity-timeline">
            <div
              v-for="activity in recent_activities"
              :key="activity.id"
              class="entity-activity-item"
            >
              <span class="entity-activity-dot" :class="activity.toneClass"></span>
              <div class="entity-activity-card rounded-3 px-3 py-2">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-1">
                  <div class="entity-activity-title fw-bold">{{ activity.title }}</div>
                  <div class="entity-activity-time text-secondary">{{ activity.timestamp }}</div>
                </div>
                <div class="entity-activity-reason text-secondary">{{ activity.reason }}</div>
              </div>
            </div>
          </div>

          <div v-else class="small text-secondary">
            No recent orchestration activity yet.
          </div>

          <button type="button" class="btn btn-light w-100 mt-3 rounded-small border entity-audit-btn">View Full Audit Log</button>
        </div>
      </div>
    </section>
  </div>
</div>
